/**
 * 解决Vue Template模板中无法使用可选链的问题
 * @param obj
 * @param rest
 * @returns {*}
 */
export const optionalChaining = (obj, ...rest) => {
  let tmp = obj;
  for (const key in rest) {
    if (Object.prototype.hasOwnProperty.call(rest, key)) {
      const name = rest[key];
      tmp = tmp?.[name];
    }
  }
  return tmp || '';
};

/**
 * 下载文件
 * @param obj 数据流
 * @param name 下载名
 * @param suffix 后缀
 * @param type 文件类型
 */
export function downloadFile(obj, name = '下载文件', suffix = 'doc', type = 'application/msword;charset=UTF-8') {
  const fileName = name;
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(new Blob([obj], { type }), fileName);
  } else {
    const url = window.URL.createObjectURL(new Blob([obj], { type }));
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  };
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'undefined' || time === null || time === 'null' || !time) {
    return '';
  } else if (typeof time === 'object') {
    date = time;
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time);
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value]; };
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return timeStr;
}

export function parseDate(time) {
  if (time) {
    var date = new Date(time);
    var year = date.getFullYear();
    /* 在日期格式中，月份是从0开始的，因此要加0
     * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
     * */
    var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    // 拼接
    return year + '-' + month + '-' + day;
  } else {
    return '';
  };
}
// 只显示姓，不过有问题是复姓没办法
export function formatName(str) {
  return str.substr(0, 1) + new Array(str.length).join('*');
}
